// extracted by css-extract-rspack-plugin
export default {"sortable":"Table__sortable--_QDsl","desc":"Table__desc--E5TVJ","asc":"Table__asc--eJDnW","table":"Table__table--qpoTv"};